import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import TestResultsMainHeader from '../../../components/TestResultsMainHeader';
import ProductPageGenerator from '../../components/ProductPageGenerator';

import { getProductPage } from '../../actions/productPage';

import './index.scss';

const ProductPage = ({
  dispatch,
  data,
  error,
  loading,
  lang,
  changeLanguage,
}) => {
  const { testCode } = useParams();

  useEffect(() => {
    dispatch(getProductPage(testCode, lang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, testCode, lang]);

  if (loading) return <div className='product-page__loader'></div>;

  return (
    <div className='product-page'>
      <TestResultsMainHeader
        availableLanguages={['en', 'de', 'fr']}
        defaultLanguage={lang}
        onChangeLanguage={changeLanguage}
        dispatch={dispatch}
        logoClassName='product-page__logo'
        className='product-page__header'
      />

      {data && !error && (
        <div className='product-page__content'>
          <ProductPageGenerator data={data} />
        </div>
      )}
    </div>
  );
};

ProductPage.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  lang: PropTypes.string,
  changeLanguage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  data: state.productPage.get('data'),
  error: state.productPage.get('error'),
  loading: state.productPage.get('loading'),
});

export default connect(mapStateToProps)(ProductPage);
